import { Address, getAddress } from "viem"
import * as chain from "viem/chains"
import * as customChains from "../../chains"
import type { SupportedChainId } from "../../config"
import { Token } from "../Token"
import {
  USDCA,
  USD_ADDRESS,
  WAVAX_ADDRESS,
  WBERA_ADDRESS,
  WBNB_ADDRESS,
  WETH9,
  WHYPE_ADDRESS,
  WMNT_ADDRESS,
  WMON_ADDRESS,
  WSONIC_ADDRESS,
  WTAC_ADDRESS,
  WXPL_ADDRESS,
} from "./token-addresses"

export const WNATIVE_ADDRESS: Record<SupportedChainId, Address> = {
  [chain.mainnet.id]: WETH9[chain.mainnet.id],
  [chain.base.id]: WETH9[chain.base.id],
  [chain.arbitrum.id]: WETH9[chain.arbitrum.id],
  [chain.foundry.id]: WETH9[chain.foundry.id],
  [chain.sepolia.id]: WETH9[chain.sepolia.id],
  [customChains.tenderly.id]: WETH9[customChains.tenderly.id],
  [customChains.bartio.id]: WETH9[customChains.bartio.id],
  [customChains.swell.id]: WETH9[customChains.swell.id],
  [customChains.ink.id]: WETH9[customChains.ink.id],
  [customChains.unichain.id]: WETH9[customChains.unichain.id],
  [customChains.bob.id]: WETH9[customChains.bob.id],
  // Networks no ETH native
  [customChains.sonic.id]: WSONIC_ADDRESS,
  [customChains.berachain.id]: WBERA_ADDRESS,
  [chain.avalanche.id]: WAVAX_ADDRESS,
  [chain.bsc.id]: WBNB_ADDRESS,
  [customChains.hyperevm.id]: WHYPE_ADDRESS,
  [customChains.tac.id]: WTAC_ADDRESS,
  [chain.linea.id]: WETH9[chain.linea.id],
  [chain.mantle.id]: WMNT_ADDRESS,
  [customChains.plasma.id]: WXPL_ADDRESS,
  [customChains.monad.id]: WMON_ADDRESS,
} as const

export const WNATIVE: Record<SupportedChainId, Token> = {
  [chain.mainnet.id]: new Token({
    chainId: chain.mainnet.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[chain.mainnet.id],
  }),
  [chain.base.id]: new Token({
    chainId: chain.base.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[chain.base.id],
  }),
  [chain.arbitrum.id]: new Token({
    chainId: chain.arbitrum.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[chain.arbitrum.id],
  }),
  [chain.foundry.id]: new Token({
    chainId: chain.foundry.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[chain.foundry.id],
  }),
  [chain.sepolia.id]: new Token({
    chainId: chain.sepolia.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[chain.sepolia.id],
  }),
  [customChains.tenderly.id]: new Token({
    chainId: customChains.tenderly.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[customChains.tenderly.id],
  }),
  [customChains.bartio.id]: new Token({
    chainId: customChains.bartio.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[customChains.bartio.id],
  }),
  [customChains.swell.id]: new Token({
    chainId: customChains.swell.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[customChains.swell.id],
  }),

  [customChains.ink.id]: new Token({
    chainId: customChains.ink.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[customChains.ink.id],
  }),
  [customChains.unichain.id]: new Token({
    chainId: customChains.unichain.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[customChains.unichain.id],
  }),
  // Networks no ETH native
  [customChains.sonic.id]: new Token({
    chainId: customChains.sonic.id,
    decimals: 18,
    symbol: "wS",
    name: "Wrapped S",
    address: WNATIVE_ADDRESS[customChains.sonic.id],
  }),
  [customChains.berachain.id]: new Token({
    chainId: customChains.berachain.id,
    decimals: 18,
    symbol: "WBERA",
    name: "Wrapped Bera",
    address: WNATIVE_ADDRESS[customChains.berachain.id],
  }),
  [chain.avalanche.id]: new Token({
    chainId: chain.avalanche.id,
    decimals: 18,
    symbol: "WAVAX",
    name: "Wrapped Avax",
    address: WNATIVE_ADDRESS[chain.avalanche.id],
  }),
  [customChains.bob.id]: new Token({
    chainId: customChains.bob.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[customChains.bob.id],
  }),
  [chain.bsc.id]: new Token({
    chainId: chain.bsc.id,
    decimals: 18,
    symbol: "WBNB",
    name: "Wrapped BNB",
    address: WNATIVE_ADDRESS[chain.bsc.id],
  }),
  [customChains.hyperevm.id]: new Token({
    chainId: customChains.hyperevm.id,
    decimals: 18,
    symbol: "WHYPE",
    name: "Wrapped Hype",
    address: WNATIVE_ADDRESS[customChains.hyperevm.id],
  }),
  [customChains.tac.id]: new Token({
    chainId: customChains.tac.id,
    decimals: 18,
    symbol: "WTAC",
    name: "Wrapped TAC",
    address: WNATIVE_ADDRESS[customChains.tac.id],
  }),
  [chain.linea.id]: new Token({
    chainId: chain.linea.id,
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    address: WNATIVE_ADDRESS[chain.linea.id],
  }),
  [chain.mantle.id]: new Token({
    chainId: chain.mantle.id,
    decimals: 18,
    symbol: "WMNT",
    name: "Wrapped Mantle",
    address: WNATIVE_ADDRESS[chain.mantle.id],
  }),
  [customChains.plasma.id]: new Token({
    chainId: customChains.plasma.id,
    decimals: 18,
    symbol: "WXPL",
    name: "Wrapped XPL",
    address: WNATIVE_ADDRESS[customChains.plasma.id],
  }),
  [customChains.monad.id]: new Token({
    chainId: customChains.monad.id,
    decimals: 18,
    symbol: "WMON",
    name: "Wrapped Monad",
    address: WNATIVE_ADDRESS[customChains.monad.id],
  }),
} as const

export const USDC: Record<SupportedChainId, Token> = {
  [chain.mainnet.id]: new Token({
    chainId: chain.mainnet.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[chain.mainnet.id],
  }),
  [chain.base.id]: new Token({
    chainId: chain.base.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[chain.base.id],
  }),
  [chain.arbitrum.id]: new Token({
    chainId: chain.arbitrum.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[chain.arbitrum.id],
  }),
  [chain.foundry.id]: new Token({
    chainId: chain.foundry.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[chain.foundry.id],
  }),
  [chain.sepolia.id]: new Token({
    chainId: chain.sepolia.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[chain.sepolia.id],
  }),
  [customChains.tenderly.id]: new Token({
    chainId: customChains.tenderly.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[customChains.tenderly.id],
  }),
  [customChains.bartio.id]: new Token({
    chainId: customChains.bartio.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[customChains.bartio.id],
  }),
  [customChains.swell.id]: new Token({
    chainId: customChains.swell.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[customChains.swell.id],
  }),
  [customChains.sonic.id]: new Token({
    chainId: customChains.sonic.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[customChains.sonic.id],
  }),
  [customChains.berachain.id]: new Token({
    chainId: customChains.berachain.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[customChains.berachain.id],
  }),
  [customChains.ink.id]: new Token({
    chainId: customChains.ink.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[customChains.ink.id],
  }),
  [customChains.unichain.id]: new Token({
    chainId: customChains.unichain.id,
    decimals: 6,
    symbol: "USDC",
    address: USDCA[customChains.unichain.id],
  }),
  [chain.avalanche.id]: new Token({
    chainId: chain.avalanche.id,
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    address: USDCA[chain.avalanche.id],
  }),
  [customChains.bob.id]: new Token({
    chainId: customChains.bob.id,
    decimals: 6,
    symbol: "USDC",
    address: USDCA[customChains.bob.id],
  }),
  [chain.bsc.id]: new Token({
    chainId: chain.bsc.id,
    decimals: 6,
    symbol: "USDC",
    address: USDCA[chain.bsc.id],
  }),
  [customChains.hyperevm.id]: new Token({
    chainId: customChains.hyperevm.id,
    decimals: 6,
    symbol: "USDC",
    address: USDCA[customChains.hyperevm.id],
  }),
  [customChains.tac.id]: new Token({
    chainId: customChains.tac.id,
    decimals: 6,
    symbol: "USDC",
    address: USDCA[customChains.tac.id],
  }),
  [chain.linea.id]: new Token({
    chainId: chain.linea.id,
    decimals: 6,
    symbol: "USDC",
    address: USDCA[chain.linea.id],
  }),
  [chain.mantle.id]: new Token({
    chainId: chain.mantle.id,
    decimals: 6,
    symbol: "USDC",
    address: USDCA[chain.mantle.id],
  }),
  [customChains.plasma.id]: new Token({
    chainId: customChains.plasma.id,
    decimals: 6,
    symbol: "USDC",
    address: USDCA[customChains.plasma.id],
  }),
  [customChains.monad.id]: new Token({
    chainId: customChains.monad.id,
    decimals: 6,
    symbol: "USDC",
    address: USDCA[customChains.monad.id],
  }),
} as const

export const USD_TOKEN = new Token({
  decimals: 8,
  symbol: "USD",
  address: USD_ADDRESS,
})

export const WSONIC_TOKEN = new Token({
  chainId: customChains.sonic.id,
  decimals: 18,
  symbol: "wS",
  address: WSONIC_ADDRESS,
})

export const WAVALANCE_TOKEN = new Token({
  chainId: chain.avalanche.id,
  decimals: 18,
  symbol: "WAVAX",
  address: WAVAX_ADDRESS,
})

export const WBERA_TOKEN = new Token({
  chainId: customChains.berachain.id,
  decimals: 18,
  symbol: "WBERA",
  address: WBERA_ADDRESS,
})

export const WBNB_TOKEN = new Token({
  chainId: chain.bsc.id,
  decimals: 18,
  symbol: "WBNB",
  address: WBNB_ADDRESS,
})

export const WHYPE_TOKEN = new Token({
  chainId: customChains.hyperevm.id,
  decimals: 18,
  symbol: "WHYPE",
  address: WHYPE_ADDRESS,
})

export const WMNT_TOKEN = new Token({
  chainId: chain.mantle.id,
  decimals: 18,
  symbol: "WMNT",
  address: WMNT_ADDRESS,
})

export const WXPL_TOKEN = new Token({
  chainId: customChains.plasma.id,
  decimals: 18,
  symbol: "WXPL",
  address: WXPL_ADDRESS,
})

export const WMON_TOKEN = new Token({
  chainId: customChains.monad.id,
  decimals: 18,
  symbol: "WMON",
  address: WMON_ADDRESS,
})

/* ------------- */
/*   Getters.    */
/* ------------- */
export function getWrappedNativeToken(chainId?: SupportedChainId) {
  if (!chainId) return undefined
  const t = WNATIVE[chainId]
  return t
}

export function getWrappedNativeAddress(
  chainId?: SupportedChainId,
): Address | undefined {
  const t = getWrappedNativeToken(chainId)
  return t ? getAddress(t.address as Address) : undefined
}
